import { api } from "../../config/api/api.config";
import { fetchSinToken } from "../../helpers/fetch/fetch"
import { iniciarSesionElsaRequest, iniciarSesionRequest } from "../../models/auth/auth.models"

export async function iniciarSesion(inicioSesionRequest: iniciarSesionRequest) {
    try {
        const resp = await fetchSinToken('auth', inicioSesionRequest, 'POST');
        if(resp.status === 401)
            throw Error("Acceso denegado")
        const body = resp.json();
        return body;
    } catch(error) {
        const e = error as Error;
        return { success: false, mensaje: e.message || "Problemas para comprobar el acceso"}
    }
}

export async function iniciarSesionElsa(inicioSesionElsaRequest: iniciarSesionElsaRequest) {
    try {
        const { data } = await api.post("login/elsa", inicioSesionElsaRequest);
        return data;
    } catch (error){
        console.error('Error al iniciar sesión:', error);
    }
}
